import { GroupBase, MultiValue, SelectInstance } from "react-select";
import { FieldValues, FieldErrors } from "react-hook-form";
import { AsyncPaginate } from "react-select-async-paginate";
import React, { Ref } from "react";

interface ISelectAsyncField<T> {
  id: string;
  label: string;
  extra?: string;
  placeholder: string;
  variant?: string;
  isMulti?: boolean;
  disabled?: boolean;
  value?: any;
  selectRef?: React.ForwardedRef<unknown>;
  loadOptions: (
    search: string,
    loadedOptions: any,
    { page }: any
  ) => Promise<any>;
  onInputChange: (value: MultiValue<T> | T) => void;
  errors: FieldErrors<FieldValues>;
  rules: {
    required?: boolean | string;
    minLength?: number | { value: number; message: string };
    maxLength?: number | { value: number; message: string };
    pattern?: RegExp | { value: RegExp; message: string };
    validate?: (value: string) => boolean | string;
  };
}

const SelectAsyncField = React.forwardRef(
  (
    props: ISelectAsyncField<any>,
    forwardRef: Ref<SelectInstance<any, boolean, GroupBase<any>>>
  ) => {
    const {
      label,
      id,
      extra,
      variant,
      disabled,
      isMulti,
      errors,
      rules,
      value,
      placeholder,
      loadOptions,
      onInputChange,
    } = props;

    return (
      <div className={`${extra}`}>
        <label
          htmlFor={id}
          className={`text-sm text-navy-700 dark:text-white ${
            variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
          } ${isMulti && "basic-multi-select"}`}
        >
          {" "}
          {label}
          {rules.required && (
            <span className="text-red-500 dark:text-red-400">*</span>
          )}
        </label>
        <AsyncPaginate
          value={value}
          filterOption={(option, rawInput) => {
            if (option.label.toLowerCase().includes(rawInput.toLowerCase())) {
              return true;
            }
            return false;
          }}
          debounceTimeout={300}
          loadOptions={loadOptions}
          placeholder={placeholder}
          menuPortalTarget={document.body}
          isMulti={isMulti}
          noOptionsMessage={() => "Data tidak ditemukan!"}
          isClearable={true}
          isDisabled={disabled}
          additional={{
            page: 1,
          }}
          onChange={(value) => onInputChange(value)}
          selectRef={forwardRef}
          className={extra}
          classNames={{
            placeholder: () =>
              `!text-gray-400 dark:text-white/50 ${
                errors[id] && "!text-red-500 dark:!text-red-400"
              }`,
            control: () =>
              `mt-2 flex !h-auto w-full items-center justify-center !rounded-xl border !bg-white/0 !pb-1 !pl-3 !pt-1 text-sm outline-none transition-all duration-300!border-gray-200 dark:!border-white/10 dark:text-white ${
                errors[id] && "!border-red-500 dark:!border-red-400"
              }`,
            option: () =>
              `!text-gray-700 dark:!text-white/50 dark:!bg-navy-700 dark:hover:!bg-navy-600 dark:focus:!bg-navy-600 dark:active:!bg-navy-600`,
            multiValueLabel: () => `!text-white dark:!text-white/50`,
            multiValueRemove: () =>
              `!text-white/75 hover:!bg-brand-600 !rounded-tr-lg !rounded-b-r-lg`,
            multiValue: () =>
              `!bg-brand-500 !rounded-lg !text-white dark:!text-white/50 dark:!bg-white/10`,
          }}
        />
        {errors[id] && (
          <span className="ml-2 mt-1 text-sm text-red-500 dark:text-red-400">
            {errors[id].message.toString()}
          </span>
        )}
      </div>
    );
  }
);

export default SelectAsyncField;
